var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sectionWithList"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}))])}
var staticRenderFns = []

export { render, staticRenderFns }